// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1JK8P","inner":"Form_inner__30cfA","range":"Form_range__yOsH2","name":"Form_name__11qlT","actions":"Form_actions__TJmZv"};